
import template from './custom-fields.html';

/**
 *  FieldsTables view model
 */
class FieldsTablesViewModel {
	constructor(page) {
		this.page = page;
		this.element = page.element;

		this.lookupValueListOptions = ko.observable({filter:[{field:'schema', operator:'=', value:''}]});
		this.selectedFieldsTable = ko.observable();
		this.selectedFieldsTable.subscribe((newValue)=>{
			this.lookupValueListOptions({filter:[
				{field:'schema', operator:'=', value:newValue.schema},
				{field:'table', operator:'=', value:newValue.table}
			]});
		});
		this.selectedLookupValue = ko.observable();

	}

}

/**
 * FieldsTables class
 */
class FieldsTablesClass {
	constructor(bindings, element) {
		this.bindings = bindings;
		this.element = element;
		this.viewModel = new FieldsTablesViewModel(this);
		this.name = 'FieldsTablesClass';

	}

	async init() {
	}

	async updateData() {
	}

	async teardown() {
	}
}

export default {
	route: '[/]ui/setup/custom-fields',
	page_id: '[/]ui/setup/custom-fields',
	page_class: FieldsTablesClass,
	template: template,
	title: 'Custom Fields',
	icon: 'fa-regular fa-list',
	idx: 10
};
